import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8 0.5C12.125 0.5 15.5 3.875 15.5 8C15.5 12.1562 12.125 15.5 8 15.5C3.84375 15.5 0.5 12.1562 0.5 8C0.5 3.875 3.84375 0.5 8 0.5ZM8 14C11.2812 14 14 11.3125 14 8C14 4.71875 11.2812 2 8 2C4.6875 2 2 4.71875 2 8C2 11.3125 4.6875 14 8 14ZM10.4688 5.5C10.75 5.1875 11.2188 5.1875 11.5 5.5C11.8125 5.78125 11.8125 6.25 11.5 6.53125L7.5 10.5312C7.375 10.6875 7.1875 10.75 7 10.75C6.78125 10.75 6.59375 10.6875 6.46875 10.5312L4.46875 8.53125C4.15625 8.25 4.15625 7.78125 4.46875 7.5C4.75 7.1875 5.21875 7.1875 5.5 7.5L7 8.96875L10.4688 5.5Z",
		fill: "#00AA84"
	})]
});
const ForwardRef = forwardRef(SvgCircleCheck);
export { ForwardRef as ReactComponent };
